/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
import React,{useState} from 'react';
import { Link, useNavigate, useSearchParams, useParams} from 'react-router-dom';
import moment from 'moment';
import CheckStatus from '../../Status';
import ManageBranchUserList from '../../../pages/ManageBranches/ManageBranchUser';
import { FormattedNumber } from '../../../CommonMethods/FormattedNumber';
import FormatDateString from '../../../CommonMethods/FromatDateString';


const ViewDetails = ({branchRecodes}) => {
    const navigate = useNavigate()
    const [tab, settab] = useSearchParams({tab: 'branch_details'});
    const [viewLoading,setViewLoading] = useState(true)
    const [searchParams, setSearchParams] = useSearchParams('')
    let {id} = useParams();

    /**
     * The function `handleNavigation` navigates to different routes based on the value of the
     * `navigation` parameter.
     */
    const handleNavigation = (navigation) => {
        if(navigation === 'branch_details') {
            navigate(`/manage-branches/${id.split('*')[0]}*branch_details`)
        } else if (navigation === "branch_users") {
            navigate(`/manage-branches/${id.split("*")[0]}*branch_users`);
        } else {
            navigate(`/manage-branches/${id.split("*")[0]}*holidays`);
        }   
    }

    /**
     * The function `handleNavigationBack` is used to navigate back to the previous page.
     */
    const handleNavigationBack = () => {
        navigate(`/manage-branches?${searchParams.toString()}`)
    }

    return (
        <>            
            <div
                className="mainDataCntnrTop shadow-s13"
            >
                <div className="flex items-center">
                    
                    <div onClick={() => {handleNavigationBack()}} className='cursor-pointer'>
                        <img src="/images/back-btnBlue.svg" alt="icon" loading="lazy"/>
                    </div>
                    <h5 className="pageHeader adderror ml-2.5">
                        View Branch
                    </h5>
                </div>
            </div>
            <div className="pb-10 relative">
                <ul
                    className="mr-4 ml-4 flex list-none flex-row flex-wrap border-b border-[#B3BBC1] pl-9 pt-6 bg-[#fff] sticky top-[64px] left-0 z-[10] -mx-1"
                    role="tablist"
                    data-te-nav-ref=""
                >
                    <li
                        onClick={() => handleNavigation('branch_details')}
                        //href={`/manage-branches/${id.split('*')[0]}*branch_details`}
                        className={`institutiondetails1 ${id.split("*")[1] === "branch_details"?'selected':''} mr-[126px] tab-element`}
                        data-te-toggle="pill"
                        data-te-target="#tabs-institutionDetails"
                        role="tab"
                        aria-controls="tabs-institutionDetails"
                        aria-selected="false"
                    >
                        Branch Details
                    </li>
                    <li  
                        onClick={() => handleNavigation('branch_users')}
                        //href={`/manage-branches/${id.split('*')[0]}*branch_users`}
                        className={`institutionList1 ${id.split("*")[1] === "branch_users"?'selected' :'font-normal'} mr-[126px] tab-element`}
                        data-te-toggle="pill"
                        data-te-target="#tabs-institutionuserList"
                        data-te-nav-active=""
                        role="tab"
                        id="branch_user_list"
                        aria-controls="tabs-institutionuserList"
                        aria-selected="false"
                    >
                        Branch Users
                    </li>
                </ul>
                {id.split("*")[1] === "branch_details" ? <div className="scroll-bar tabbedPgListDiv">
                    <div
                        className={`opacity-100 transition-opacity duration-150 ease-linear data-[te-tab-active]:block ${tab.get('tab')}`}
                        id="tabs-institutionDetails"
                        role="tabpanel"
                        aria-labelledby="tabs-institutionDetails-tab"
                    >
                        <div className="w-[85%] mx-auto">
                            {branchRecodes.status && <div className="flex justify-end">
                                <Link to={`/manage-branches/onboard-new-branch/edit/${id.split('*')[0]}`} className="view-actn-btn">
                                    Edit
                                </Link>
                            </div>}
                            <div className="border rounded border-[#D0D5DD] p-4 mt-2.5">
                                <div className="flex -mx-2">
                                    <div className="w-[55%] px-2">
                                        <div className="w-full">
                                            <div className="flex items-center">
                                                <p className="text-f7 font-normal text-[#031624] min-w-[130px] self-start">
                                                    Branch Name
                                                </p>
                                                <div className="flex items-center">
                                                    <p className="text-f7 font-semibold text-[#031624] break-all">
                                                        {branchRecodes?.branch_name}
                                                    </p>
                                                    {!branchRecodes.status&& <CheckStatus state={branchRecodes.status}/>}
                                                    
                                                </div>
                                            </div>
                                            <div className="flex items-center mt-6">
                                                <p className="text-f7 font-normal text-[#031624] min-w-[130px] self-start">
                                                    Address{" "}
                                                </p>
                                                <div className="flex items-center">
                                                    <p className="text-f7 font-semibold text-[#031624] break-words self-start">
                                                        {branchRecodes?.address_line_1}, {branchRecodes?.address_line_2}
                                                        <br />
                                                        {branchRecodes?.area}, {branchRecodes?.city} <br />
                                                        {branchRecodes?.state} - {branchRecodes?.pincode}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="flex items-center mt-4">
                                                <p className="text-f7 font-normal text-[#031624] min-w-[130px]">
                                                    PAN
                                                </p>
                                                <div className="flex items-center">
                                                    <p className="text-f7 font-semibold text-[#031624] break-words">
                                                        {branchRecodes?.pan_number}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="flex items-center mt-4">
                                                <p className="text-f7 font-normal text-[#031624] min-w-[130px]">
                                                    GSTIN
                                                </p>
                                                <div className="flex items-center">
                                                    <p className="text-f7 font-semibold text-[#031624] break-words">
                                                        {branchRecodes?.gst_number || '-'}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-[45%] px-2">
                                        <div className="w-full">
                                            <h5 className="text-f7 font-semibold text-[#000000] break-words">
                                                Point of Contact
                                            </h5>
                                            <div className="pb-4 border-b-2 border-[#95C0E0]">
                                                <div className="flex items-start mt-2">
                                                    <p className="text-f7 font-normal text-[#031624] min-w-[150px]">
                                                        Name
                                                    </p>
                                                    <div className="flex items-center">
                                                        <p className="text-f7 font-semibold text-[#031624] break-words">
                                                            {branchRecodes?.poc_name}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="flex items-start mt-4">
                                                    <p className="text-f7 font-normal text-[#031624] min-w-[150px]">
                                                        Email Address
                                                    </p>
                                                    <div className="flex items-center">
                                                        <p className="text-f7 font-semibold text-[#031624] break-all">
                                                            {branchRecodes?.poc_email_address}                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="flex items-center mt-4">
                                                    <p className="text-f7 font-normal text-[#031624] min-w-[150px]">
                                                        Mobile Number
                                                    </p>
                                                    <div className="flex items-center">
                                                        <p className="text-f7 font-semibold text-[#031624] break-words">
                                                            {FormattedNumber(branchRecodes?.poc_mobile_number)}                                                        
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="flex items-center mt-4 border-t border-[#e7e7e7]">
                                                    <p className="text-f7 font-normal text-[#031624] min-w-[150px]  pt-[10px]">
                                                        Starting FY
                                                    </p>
                                                    <div className="flex items-center  pt-[10px]">
                                                        <p className="text-f7 font-semibold text-[#031624] break-words">
                                                            {FormattedNumber(branchRecodes?.starting_financial_year)}                                                        
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="flex items-center mt-4">
                                                    <p className="text-f7 font-normal text-[#031624] min-w-[150px]">
                                                        Clock-in/Clock-out
                                                    </p>
                                                    <div className="flex items-center">
                                                        <p className="text-f7 font-semibold text-[#031624] break-words">
                                                            {FormattedNumber(branchRecodes?.clock_in_out_facitilty?'Enabled':'Disabled')}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div className="pt-4">
                                                <p className="text-f7 font-normal text-[#031624]">
                                                    Created on {FormatDateString(branchRecodes.created_at)} by {branchRecodes.created_by}
                                                </p>
                                                <p className="text-f7 font-normal text-[#031624] pt-4">
                                                    Last Updated on {FormatDateString(branchRecodes.updated_at)} by {branchRecodes.updated_by}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> :
                    id.split("*")[1] === "branch_users" && (
                        <ManageBranchUserList
                            id={id}
                            BranchDisabled={branchRecodes.status}
                            branchName={branchRecodes.branch_name}
                            loading={viewLoading}
                            setLoading={setViewLoading}
                        />
                    )  
                }
            </div>
        </>
    );
}

export default ViewDetails;
